import { useAbility } from '@casl/react';
import { ElementType, FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { RootState } from 'store';
import { AbilityContext } from 'utils/permissions/Can';
import { Actions, Subjects } from 'utils/permissions/permissionsAndFeatures';
import useBreakpoint from 'hooks/useBreakpoint';

const APP_THEME = process.env.REACT_APP_THEME;
interface Props extends RouteProps {
  comp: ElementType;
  redirectOnMobileTo?: string;
  compProps?: Record<string, unknown>;
  fallback?: string;
  permission?: {
    can: Actions;
    resourceName: Subjects;
  };
  shouldRedirect?: boolean;
}
const ProtectedRoute: FC<Props> = ({
  comp: Component,
  redirectOnMobileTo,
  fallback = '/signup/wechooose',
  permission,
  shouldRedirect,
  compProps,
  ...props
}) => {
  const { isMobile } = useBreakpoint();
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const accounts = useSelector((state: RootState) => state.user.accounts);
  const ability = useAbility(AbilityContext);
  const hasNotPermission = permission && !ability.can(permission.can, permission.resourceName);
  const isNotAuthenticated = !isAuthenticated;
  const hasNotCustomerSetup = !accounts || accounts.length === 0;

  return (
    <Route
      {...props}
      render={(): ReactElement => {
        if (isNotAuthenticated || hasNotPermission || shouldRedirect) {
          return <Redirect to={fallback} />;
        }
        if (hasNotCustomerSetup) {
          return <Redirect to={APP_THEME === 'corporate' ? '/signup/wechooose' : '/signup'} />;
        }
        if (isMobile && redirectOnMobileTo) {
          return <Redirect to={redirectOnMobileTo} />;
        }
        return <Component {...compProps} />;
      }}
    />
  );
};

export default ProtectedRoute;
